import { NavLink } from "react-router-dom";
import { useState } from "react";
import logo from "../img/logo.jpg";
import "./Navbar.css";

const Navbar = () => {
  const [open, setOpen] = useState(false);
  
  return (
    <header className="navbar">

      <div className="navbar-logo">
        <img src={logo} alt="logo" />
        Dunaújvárosi Judo Club
      </div>

      <nav className="navbar-nav desktop">
        <NavLink to="/" end>Rólunk</NavLink>
        <NavLink to="/trainings">Ahol edzéseink zajlanak</NavLink>
        <NavLink to="/offer">Amit kínálunk</NavLink>
        <NavLink to="/social">Közösségünk</NavLink>
        <NavLink to="/founder">Alapítónk</NavLink>
        <NavLink to="/trainer">Edzőnk</NavLink>
        <NavLink to="/support">Támogatás</NavLink>
        <NavLink to="/galery">Galéria</NavLink>
        <NavLink to="/contact">Kapcsolat</NavLink>
      </nav>
      <button
        className="hamburger"
        onClick={() => setOpen(!open)}
        aria-label="Menü" >
        <span />
        <span />
        <span />
      </button>

      {/* Mobile Menu */}
      <nav className={`mobile-nav ${open ? "open" : ""}`}>
        <NavLink to="/" end  onClick={() => setOpen(false)}>Rólunk</NavLink>
        <NavLink to="/trainings"  onClick={() => setOpen(false)}>Ahol edzéseink zajlanak</NavLink>
        <NavLink to="/offer"  onClick={() => setOpen(false)}>Amit kínálunk</NavLink>
        <NavLink to="/social" onClick={() => setOpen(false)}>Közösségünk</NavLink>
        <NavLink to="/founder"  onClick={() => setOpen(false)}>Alapítónk</NavLink>
        <NavLink to="/trainer"  onClick={() => setOpen(false)}>Edzőnk</NavLink>
        <NavLink to="/support"  onClick={() => setOpen(false)}>Támogatás</NavLink>
        <NavLink to="/galery"  onClick={() => setOpen(false)}>Galéria</NavLink>
        <NavLink to="/contact"  onClick={() => setOpen(false)}>Kapcsolat</NavLink>
      </nav>
    </header>
  );
};

export default Navbar;